import { BsCheck2Circle, BsExclamationTriangleFill, BsInfoCircle } from "react-icons/bs";
import { FaCalendarPlus } from "react-icons/fa6";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const InfoTooltip = ({ id, text }) => (
  <OverlayTrigger
    placement="top"
    overlay={<Tooltip id={id}>{text}</Tooltip>}
  >
    <span className="ms-auto d-inline-flex align-items-center">
      <BsInfoCircle className="text-info" />
    </span>
  </OverlayTrigger>
);

const PmSummaryCards = ({ maintenanceDateCount }) => {
  return (
    <div className="row g-4">
      <div className="col-md-4">
        <div className="pm_summary_card">
          <div
            className="fw-semibold d-flex align-items-center mb-4"
            style={{ color: "#4F19E2" }}
          >
            <FaCalendarPlus size={20} className="me-2" />
            Upcoming PMs
            <InfoTooltip
              id="upcoming-pms-tooltip"
              text="Preventive maintenance tasks scheduled for upcoming dates."
            />
          </div>
          <div
            className="display-5 fw-bold text-center"
            style={{ color: "#4F19E2" }}
          >
            {maintenanceDateCount?.upcoming_pm}
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div className="pm_summary_card">
          <div className="text-danger fw-semibold d-flex align-items-center mb-4">
            <BsExclamationTriangleFill size={20} className="me-2" />
            Overdue PMs
            <InfoTooltip
              id="overdue-pms-tooltip"
              text="Preventive maintenance tasks whose scheduled date has passed."
            />
          </div>
          <div className="display-5 fw-bold text-danger text-center">
            {maintenanceDateCount?.overdue_pm}
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div className="pm_summary_card">
          <div
            className="fw-semibold d-flex align-items-center mb-4"
            style={{ color: "#16A34A" }}
          >
            <BsCheck2Circle size={20} className="me-2" />
            Completed PMs
            <InfoTooltip
              id="completed-pms-tooltip"
              text="Preventive maintenance tasks completed within the selected period."
            />
          </div>
          <div
            className="display-5 fw-bold text-center"
            style={{ color: "#16A34A" }}
          >
            {maintenanceDateCount?.completed_pm}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PmSummaryCards;
